import { theme } from 'antd';
import { useOtp } from '@hooks/useOtp';
import { Form, Input, Button, Breadcrumb } from 'antd';
import { Container, AuthCard, BreadcrumbWrapper, StyledLink } from '../style';
import { HomeOutlined, KeyOutlined, ClockCircleOutlined, ReloadOutlined } from '@ant-design/icons';

const Otp = () => {
    const { form, loading, countdown, resendLoading, email, onFinish, handleResendOtp, formatTime } = useOtp();

    const breadcrumbItems = [
        {
            title: (
                <StyledLink to="/sign-in">
                    <HomeOutlined /> Sign In
                </StyledLink>
            ),
        },
        {
            title: (
                <StyledLink to="/forgot-password">
                    <KeyOutlined /> Forgot Password
                </StyledLink>
            ),
        },
        {
            title: '',
        },
    ];

    return (
        <Container>
            <AuthCard title="OTP Verification">
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item
                        name="otp"
                        label="Enter OTP"
                        rules={[{ required: true, message: 'Please input the OTP!' }]}
                    >
                        <Input.OTP
                            length={6}
                            size="large"
                            separator={<span style={{ color: theme.mode === 'dark' ? '#ffffff' : '#000000' }}>-</span>}
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '5px',
                            }}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" block loading={loading}>
                            Verify OTP
                        </Button>
                    </Form.Item>
                    <Button
                        size="large"
                        type={countdown > 0 ? 'default' : 'secondary'}
                        onClick={handleResendOtp}
                        disabled={countdown > 0}
                        loading={resendLoading}
                        icon={countdown > 0 ? <ClockCircleOutlined /> : <ReloadOutlined />}
                        block
                    >
                        {countdown > 0 ? `Resend OTP (${formatTime(countdown)})` : 'Resend OTP'}
                    </Button>
                </Form>
            </AuthCard>
            <BreadcrumbWrapper>
                <Breadcrumb items={breadcrumbItems} />
            </BreadcrumbWrapper>
        </Container>
    );
};

export default Otp;
